function formEfects(){
    const getAllforms = document.querySelectorAll('.form-contact');
    getAllforms.forEach(function(form){
        const getAllInputs = form.querySelectorAll('input');
        const getAllTextArea = form.querySelectorAll('textarea');
        getAllInputs.forEach(function(input){
            if(!input.classList.contains('wpcf7-submit')){

                if (input.getAttribute('type') == 'file'){
                    let svgDown = document.createElement('div');
                    svgDown.innerHTML = '<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.13659 0V11.4525L3.07993 8.5275L1.84326 9.72L6.99993 14.6925L12.1566 9.72L10.9199 8.5275L7.88659 11.4525V0H6.13659Z" fill="white"/><path d="M14 16.3125H0V18H14V16.3125Z" fill="white"/></svg>';
                    input.after(svgDown);
                    svgDown.classList.add('svg-down');
                }

                const getLabel = input.parentNode.previousSibling;
                input.onfocus = function(){
                    getLabel.classList.add('active');
                    input.classList.add('active');
                }
                input.onblur = function(){
                    if(input.value == ''){
                        getLabel.classList.remove('active');
                        input.classList.remove('active');
                    }
                }
                input.onchange = function(){
                    if (input.getAttribute('type') == 'file'){
                        if(input.value == ''){
                            getLabel.classList.remove('active');
                            input.classList.remove('active');
                        }else{
                            getLabel.classList.add('active');
                            input.classList.add('active');
                        }
                        if (input.classList.contains('active')){
                            if(input.parentNode.querySelector('.file-text') != null){
                                input.parentNode.querySelector('.file-text').remove()
                            }
                            let getFileStr = input.files[0].name;
                            let elemFileText = document.createElement('span');
                            input.parentNode.append(elemFileText);
                            elemFileText.classList.add('file-text');
                            elemFileText.innerHTML = getFileStr;
                        }
                    }
                }

            }
        });
        getAllTextArea.forEach(function(input){
            const getLabel = input.parentNode.previousSibling;
            input.onfocus = function(){
                getLabel.classList.add('active');
                input.classList.add('active');
            }
            input.onblur = function(){
                if(input.value == ''){
                    getLabel.classList.remove('active');
                    input.classList.remove('active');
                }
            }
            input.onkeyup = function(){
                if (input.scrollHeight > input.clientHeight) {
                    input.style.height = input.scrollHeight + "px";
                }else{
                    input.style.height = input.clientHeight - 22 + "px";
                }
            }
        });
    });
}
module.exports = formEfects;